import AppLayout from '../views/layouts/AppLayout'

export default [
  {
    path: '/settings/ac-years',
    name: 'settings.ac-years.index',
    component: () => import(/* webpackChunkName: "settings_ac-years_index" */ '../views/settings/ac-years/Index.vue'),
    meta: {
      layout: AppLayout,
      pageTitle: 'ปีการศึกษาและงบประมาณ',
      bodyClass: 'app-page',
      title: 'ปีการศึกษา/งบประมาณ'
    }
  },
  {
    path: '/settings/ac-years/:id',
    name: 'settings.ac-years.show',
    component: () => import(/* webpackChunkName: "settings_ac-years_show" */ '../views/settings/ac-years/Show.vue'),
    meta: {
      layout: AppLayout,
      pageTitle: 'รายละเอียดปีการศึกษาและงบประมาณ',
      bodyClass: 'app-page',
      title: 'รายละเอียดปีการศึกษาและงบประมาณ'
    }
  }
  // {
  //   path: '/settings/groups/:id/edit',
  //   name: 'settings.groups.edit',
  //   component: () => import(/* webpackChunkName: "settings_groups_edit" */ '../views/settings/groups/Edit.vue'),
  //   meta: {
  //     layout: AppLayout,
  //     pageTitle: 'แก้ไขหน่วยงาน',
  //     bodyClass: 'app-page',
  //     title: 'แก้ไขหน่วยงาน'
  //   }
  // }
]
